// telecallingTypes.js
export const REQUEST_LEAD_TEXTFIELD_DETAILS  = "REQUEST_LEAD_TEXTFIELD_DETAILS";
export const RECEIVED_LEAD_TEXTFIELD_DETAILS = "RECEIVED_LEAD_TEXTFIELD_DETAILS";
export const REQUEST_ALL_TEXTFIELD_DETAILS  = "REQUEST_ALL_TEXTFIELD_DETAILS";
export const RECEIVED_ALL_TEXTFIELD_DETAILS = "RECEIVED_ALL_TEXTFIELD_DETAILS";
export const RECEIVED_ERROR = "RECEIVED_ERROR";